import Loader from 'components/loader/Loader';
import useAppModal from 'hooks/useAppModal';

const useLoaderModal = () => {
  const { openModal, closeModal } = useAppModal();
  const modalId = 'loader-modal';

  const openLoaderModal = () => {
    openModal({
      customContent: <Loader />,
      id: modalId,
      backdrop: 'static',
    });
  };

  const closeLoaderModal = () => {
    closeModal(modalId);
  };

  return { openLoaderModal, closeLoaderModal };
};

export default useLoaderModal;
